module.exports = __webpack_public_path__ + "static/media/desktop-hb-point-bg.9a0fc651.svg";